import raw from "./articles.json";

export const CATEGORIES = ["Corporate Law", "Litigation", "Constitutional Law", "Career", "Legal Research"];

const fallbackImages = {
  "Corporate Law": "/images/articles/corporate-1.jpg",
  "Litigation": "/images/articles/litigation-1.jpg",
  "Constitutional Law": "/images/articles/constitutional-1.jpg",
  "Career": "/images/articles/career-1.jpg",
  "Legal Research": "/images/articles/research-1.jpg",
};

const stripHtml = html => (html || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

export const articles = raw.map(a => ({
  ...a,
  readingTime: Math.max(1, Math.round((a.words || 300) / 200)),
  image: a.image || fallbackImages[a.category] || fallbackImages["Legal Research"],
  excerpt: (() => {
    const first = a.blocks.find(b => b.t === "p");
    const text = stripHtml(first ? first.html : "");
    return text.length > 165 ? `${text.slice(0, 165).trim()}…` : text;
  })(),
}));

export const featuredArticles = articles.filter(a => a.featured);
export const getArticle = slug => articles.find(a => a.slug === slug);
export const relatedArticles = (article, count = 3) =>
  articles.filter(a => a.slug !== article.slug && a.category === article.category).slice(0, count);

const SAVED_KEY = "advokit_saved";
export const getSaved = () => {
  try { return JSON.parse(localStorage.getItem(SAVED_KEY)) || []; } catch { return []; }
};
export const isSaved = slug => getSaved().includes(slug);
export const toggleSave = slug => {
  const saved = getSaved();
  const i = saved.indexOf(slug);
  if (i >= 0) saved.splice(i, 1); else saved.push(slug);
  localStorage.setItem(SAVED_KEY, JSON.stringify(saved));
  return saved;
};
